<script>
import {userService} from "@/services";
import {mapActions, mapState} from "vuex";
import swal from "sweetalert";
export default {
  name: "Settings2FA",
  data() {
    return {
      qrCodeUrl: "", // The URL to generate the QR code
      otpAuthUrl: "", // Deep link for authenticator apps
      verificationCode: "", // The code entered by the user
      message: "", // Status message to show feedback
      error: "" // Error message to show validation errors
    };
  },
  computed: {
    ...mapState('account', ['userdetails']),
    is2FAEnabled: function() {
      return this.userdetails != null && this.userdetails.is2FaEnabled;
    },
    wymuszona_zmiana: function() {
        return this.$route.query.force;
    }

  },
  methods: {
    ...mapActions("account", ["getpermissions"]),
    enable2FA()  {
      userService.enable2FA().then(response => {
        this.qrCodeUrl = response.data.result.base64QRCode;
        this.otpAuthUrl = response.data.result.otpAuthUrl;
      }).catch(error => {
        this.error = error.response.data.message;
      });
    },

    verify2FA() {
      this.error = '';
      if (!this.verificationCode || this.verificationCode.length === 0) {
        this.error = "Wprowadź kod 2FA";
        return;
      }
      if (!/^\d{6}$/.test(this.verificationCode)) {
        this.error = "Kod 2FA musi składać się z 6 cyfr";
        return;
      }

      userService.verifyTwoFactorCode({code: this.verificationCode}).then(() => {
        this.getpermissions();
        this.message = "Uwierzytelnianie dwuskładnikowe zostało pomyślnie włączone.";
        this.error = "";

        if(this.wymuszona_zmiana)
        {
          const loggedIn = localStorage.getItem('user');
          if (loggedIn) {
            const obj = JSON.parse(loggedIn)
            obj.forceSet2FAAtLogin = false
            localStorage.setItem('user', JSON.stringify(obj));
          }
          swal("Gotowe", "Uwierzytelnianie dwuskładnikowe zostało pomyślnie włączone.", "success").then(() => {
            this.$router.push('/')
          });

        }

      }).catch(error => {
        this.error = error.response.data.message;
      });

    },

    reset() {
      // Reset all 2FA-related state
      this.qrCodeUrl = "";
      this.otpAuthUrl = "";
      this.verificationCode = "";
      this.message = "";
      this.error = "";
    }
  }
};
</script>

<template>
  <v-container class="settings-2fa" fluid>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card elevation="2" class="pa-4">
          <v-card-title class="text-center">
            <h2>Uwierzytelnianie dwuskładnikowe</h2>
          </v-card-title>
          <v-card-text>
            <!-- Enable 2FA Section -->
            <div v-if="!qrCodeUrl && !is2FAEnabled">
              <p class="text-center mb-4">
                Włącz uwierzytelnianie dwuskładnikowe, aby dodać dodatkowy poziom zabezpieczeń do swojego konta.
              </p>
              <v-btn color="primary" block @click="enable2FA">
                Włącz
              </v-btn>
              <v-alert v-if="error" type="error" outlined class="mt-3">{{ error }}</v-alert>
            </div>

            <!-- QR Code and Verification Section -->
            <div v-if="qrCodeUrl && !is2FAEnabled">
              <!-- Deep link for mobile devices -->
              <v-alert type="info" outlined class="mb-4">
                <div class="text-center">
                  <p class="mb-2">Jeśli korzystasz z tego urządzenia i masz zainstalowaną aplikację uwierzytelniającą:</p>
                  <v-btn
                      color="primary"
                      :href="otpAuthUrl"
                      class="mb-2"
                  >
                    <v-icon left>fa-mobile-alt</v-icon>
                    Otwórz w aplikacji
                  </v-btn>
                </div>
              </v-alert>

              <v-divider class="mb-4"></v-divider>

              <p class="mb-4 text-center">
                Lub zeskanuj ten kod QR za pomocą aplikacji uwierzytelniającej na innym urządzeniu:
              </p>
              <img :src="qrCodeUrl" alt="QR Code" class="qr-code mx-auto" />
              <div class="text-center mt-4 d-flex flex-wrap justify-center">
                <v-btn
                    color="primary"
                    outlined
                    href="https://play.google.com/store/apps/details?id=com.azure.authenticator"
                    target="_blank"
                    class="mr-2 mb-2 d-flex align-center"
                >
                  <v-icon left>fab fa-android</v-icon> Microsoft Authenticator
                </v-btn>

                <v-btn
                    color="secondary"
                    outlined
                    href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                    target="_blank"
                    class="mr-2 mb-2 d-flex align-center"
                >
                  <v-icon left>fab fa-android</v-icon> Google Authenticator
                </v-btn>

                <v-btn
                    color="primary"
                    outlined
                    href="https://apps.apple.com/app/microsoft-authenticator/id983156458"
                    target="_blank"
                    class="mr-2 mb-2 d-flex align-center"
                >
                  <v-icon left>fab fa-apple</v-icon> Microsoft Authenticator
                </v-btn>

                <v-btn
                    color="secondary"
                    outlined
                    href="https://apps.apple.com/app/google-authenticator/id388497605"
                    target="_blank"
                    class="mb-2 d-flex align-center"
                >
                  <v-icon left>fab fa-apple</v-icon> Google Authenticator
                </v-btn>
              </div>

              <v-text-field
                  v-model="verificationCode"
                  label="Wprowadź kod z aplikacji"
                  outlined
                  dense
                  class="mt-4"
              ></v-text-field>

              <v-btn color="success" block class="mt-3" @click="verify2FA">
                Zweryfikuj i Włącz
              </v-btn>
              <v-btn color="secondary" block class="mt-2" @click="reset">
                Anuluj
              </v-btn>

              <v-alert v-if="error" type="error" outlined class="mt-3">{{ error }}</v-alert>
              <v-alert v-if="message" type="success" outlined class="mt-3">{{ message }}</v-alert>
            </div>

            <!-- Success Message -->
            <div v-if="is2FAEnabled">
              <v-alert type="success" outlined>
                Uwierzytelnianie dwuskładnikowe zostało włączone dla Twojego konta.
              </v-alert>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.settings-2fa {
  padding: 20px;
}

.qr-code {
  margin: 20px auto;
  display: block;
  max-width: 200px;
}
</style>
